import React from 'react';
import { Field } from 'react-final-form';
import { FormApi } from 'final-form';

import genderIcons from '../../../svg/createOfferGenderIcons';
import Checkbox from '../../Checkbox';

interface GenderProps {
  name: string;
  updateField: Function;
  field: string;
}

const GenderField = ({ name, updateField, field }: GenderProps) => (
  <div className="col2">
    <Field
      name={field}
      render={({ input, ...rest }) => (
        <>
          {field === 'shared_spots' ? (
            <>
              {genderIcons('female', input.value === '')} &nbsp;
              {genderIcons('male', input.value === '')}
            </>
          ) : (
            genderIcons(field, input.value === '')
          )}
          <div style={{ fontSize: '10px', textAlign: 'center' }}>{name}</div>
          <br />
          <Checkbox flip={() => updateField(field)} status={input.value !== ''} {...rest} />
          <pre>{input.value}</pre>
        </>
      )}
    />
  </div>
);

interface Props {
  values: CreateOffer;
  form: FormApi<CreateOffer>;
}

class GroupGenderPicker extends React.Component<Props, {}> {
  
  updateField(name: string) {
    const value = this.props.values.group_max_size * this.props.values.group_max_number;
    this.props.form.mutators.calculateSpot('female_spots', '');
    this.props.form.mutators.calculateSpot('male_spots', '');
    this.props.form.mutators.calculateSpot('shared_spots', '');
    this.props.form.mutators.calculateSpot(name, value);
  }

  render() {
    return (
      <>
        <GenderField field="shared_spots" name="Either" updateField={this.updateField.bind(this)} />
        <GenderField field="female_spots" name="Female" updateField={this.updateField.bind(this)} />
        <GenderField field="male_spots" name="Male" updateField={this.updateField.bind(this)} />
      </>
    );
  }
}
export default GroupGenderPicker;
